import { BrandOverlayEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayUnUseVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayUnUseVO.validationSchema(),
    BrandOverlayEntity
  );

  constructor(readonly value: RoomBrandOverlayUnUse) {
    JsonSchemaValidator.assert(RoomBrandOverlayUnUseVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandOverlay"],
      properties: {
        roomId,
        brandOverlay: {
          instanceof: BrandOverlayEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandOverlayUnUse {
  roomId: RoomId;
  brandOverlay: BrandOverlayEntity;
}
